export function PageHeader({ title, subtitle, children }) {
    return (
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-7">
            <div>
                <h1 className="font-heading text-3xl md:text-4xl font-black tracking-tighter text-white">{title}</h1>
                {subtitle && <p className="mt-1.5 text-sm text-muted-foreground max-w-2xl">{subtitle}</p>}
            </div>
            {children && <div className="flex items-center gap-3 shrink-0">{children}</div>}
        </div>
    );
}
